import { createAsyncThunk } from '@reduxjs/toolkit';
import { checkIfTicketHasSomeSmsChannels } from 'services/smsConversations';
import { ICheckIfTicketHasSomeChannelsParams } from 'services/smsConversations/types';

interface IProps {
  crmId: number;
  ticketId: number | string;
}

export const ThunkCheckIfTicketHasSomeSmsChannels = createAsyncThunk<
  ICheckIfTicketHasSomeChannelsParams,
  IProps
>('pod/checkIfTicketHasSomeSmsChannels', async payload => {
  const r = await checkIfTicketHasSomeSmsChannels(payload);
  return r.data;
});
